module.exports = __webpack_public_path__ + "assets/img/mr12.6836f6ac.png";